import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { LS_AUTHORITY_KEY, USER_ROLE } from "../../../core/constants/common";
import GeneralDisclosureService from "../../../core/service/GeneralDisclosureService";
import { BiPlusCircle } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";

const GDQuestionFormAdminPopup = ({ t, saveCallback, disclosureId, question }) => {

  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [show, setShow] = useState(true);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState(
    question.id > 0 
    ? question 
    : {children: [], singleAnswer: true}
  );

  const handleClose = () => {
    setShow(false);
    saveCallback(false);
  };

  const handleSave = () => {
    if (question.id > 0) {
      formData.id = question.id;
    }
    GeneralDisclosureService.addOrUpdateQuestion(disclosureId, formData, authority.roles.includes(USER_ROLE.SUPER_ADMIN))
    .then((response) => {
      setShow(false);
      if (response.status !== 201 && response.status !== 200) return;

      saveCallback(true);
    }).catch((error) => {
      setShow(false);
      saveCallback(false);
    });
    setValidated(true);
  };

  const renderQuestionFields = (qIndex = -1) => {
    const nameValue = qIndex >= 0 ? formData.children[qIndex]?.name : formData?.name;
    const codeValue = qIndex >= 0 ? formData.children[qIndex]?.code : formData?.code;
    const helpTextValue = qIndex >= 0 ? formData.children[qIndex]?.helpText : formData?.helpText;
    const singleAnswerValue = qIndex >= 0 ? formData.children[qIndex]?.singleAnswer : formData?.singleAnswer;
    return (
      <div id={`questionContainer-${qIndex + 1}`} key={`questionContainer-${qIndex + 1}`} className="Single_RC_01">
        <div className="Single_RC_Row01 m-0">
          <div className="p-2">
            <label className="mb-1">{t("Name.label")} *</label>
            <input
              type="text"
              className="form-control"
              required
              value={nameValue}
              onChange={(e) => {
                if (qIndex >= 0 ){
                  const q = JSON.parse(JSON.stringify(formData));
                  q.children[qIndex].name =  e.target.value;
                  setFormData(q);
                } else {
                  setFormData({ ...formData, name: e.target.value });
                }                
              }}
            />
          </div>
        </div>
        <div className="Single_RC_Row01 m-0">
          <div className="row m-0">
            <div className="col-lg-6 p-2">
              <label className="mb-1">{t("Code.label")} *</label>
              <input
                type="text"
                className="form-control"
                required
                value={codeValue}
                onChange={(e) => {
                  if (qIndex >= 0 ){
                    const q = JSON.parse(JSON.stringify(formData));
                    q.children[qIndex].code =  e.target.value;
                    setFormData(q);
                  } else {
                    setFormData({ ...formData, code: e.target.value });
                  }
                }}
              />
            </div>            
          </div>
        </div>
        <div className="Single_RC_Row01 m-0">
          <div className="p-2">
            <label className="mb-1">{t("HelpText.label")}</label>
            <textarea
              className="form-control"
              required
              value={helpTextValue}
              onChange={(e) => {
                if (qIndex >= 0 ){
                  const q = JSON.parse(JSON.stringify(formData));
                  q.children[qIndex].helpText =  e.target.value;
                  setFormData(q);
                } else {                  
                  setFormData({ ...formData, helpText: e.target.value });
                }
              }}>
            </textarea>
          </div>
          <div className="p-2 d-flex align-items-inline">
            <input className="form-check-input" type="checkbox"
              id={`singleAnswerCheckbox-${qIndex}`}
              checked={singleAnswerValue}
              onChange={() => {
                if (qIndex >= 0 ){
                  const q = JSON.parse(JSON.stringify(formData));
                  q.children[qIndex].singleAnswer =  !singleAnswerValue;
                  setFormData(q);
                } else {                  
                  setFormData({ ...formData, singleAnswer: !singleAnswerValue });
                }
              }} />
            <label className="form-check-label mx-1" htmlFor={`singleAnswerCheckbox-${qIndex}`}>
              {t("SingleAnswer.label")}
            </label>
          </div>
        </div>
      </div>
    );
  };

  const onAddNewSubQuestion = () => {
    const q = JSON.parse(JSON.stringify(formData));
    if (!q.children) {
      q.children = [];
    }
    q.children.push({
      name: '',
      code: '',
      helpText: '',
      singleAnswer: true
    });
    setFormData(q);
  };


  const onDeleteSubQuestion = (qIndex) => {
    const q = JSON.parse(JSON.stringify(formData));
    if (q.children[qIndex]) {
      q.children.splice(qIndex, 1);
    }
    setFormData(q);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
           <Modal.Title as="h5">
            {question.id > 0 ? t("EditQuestion.label") : t("NewQuestion.label")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
          {renderQuestionFields()}
          {formData.children?.length > 0 && <h5>{t('SubQuestions.label')}</h5>}
          {
            formData.children
            ?.sort((a, b) => a.sortOrder - b.sortOrder)
            ?.map((child, cIndex) => {
              return (
                <div className="card mt-4">
                  <div className="card-header">
                    <span className="float-left">{t('SubQuestion.label')} {cIndex + 1}</span>
                    <span className="float-right cursor" onClick={() => onDeleteSubQuestion(cIndex)}><AiOutlineDelete/></span>
                  </div>
                  <div className="card-body">
                  {renderQuestionFields(cIndex)}
                  </div>
                </div>
              );
            })
          }
          <a className="text-primary cursor" onClick={() => onAddNewSubQuestion()}>
            <BiPlusCircle className="me-2"></BiPlusCircle>{t('AddSubQuestion.label')}
          </a>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSave} className="sbmBtn">
            {question.id > 0 ? t("Update.label") : t("Create.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default withTranslation()(GDQuestionFormAdminPopup);
